import React from 'react'

import Tutorial from '../../generic/CourseSummary'
import MoreButton from '../../generic/MoreButton'
import CourseListPlaceholder from '../CourseListPlaceholder'

function FeaturedCourses({ tutorials }) {
  return tutorials.length > 0 ? (
    <section className="tutorials wrapper">
      <h2 className="tutorials__title">Featured Courses</h2>
      <div className="list">
        {tutorials.map((tutorial) => (
          <Tutorial
            key={tutorial.id}
            slug={tutorial.slug}
            summary={tutorial.description}
            teacher={tutorial.artist.title}
            teacherSlug={tutorial.artist.slug}
            title={tutorial.title}
            thumb={tutorial.photo.boxThumb}
            new={tutorial.new}
            className="tutorial"
          />
        ))}
      </div>
      <MoreButton url="/tutorials" />
    </section>
  ) : (
    <CourseListPlaceholder title="Featured Courses" />
  )
}

export default FeaturedCourses
